module.exports = __webpack_public_path__ + "img/icon-question-arrow.703f7d82.svg";